module.exports = __webpack_public_path__ + "static/media/gy.6cd4096e.svg";